import type { VoiceSnapshot } from '../voice/VoiceController';
import { Icon } from './Icon';
import { micIsOn, micStateText } from './micState';

/** Mic state as an icon: green = active/ready, red = off (muted, blocked, not entered). */
export function MicIndicator({ s, pttKey }: { s: VoiceSnapshot; pttKey: string }) {
  const on = micIsOn(s);
  const text = micStateText(s, pttKey);
  return (
    <span
      className={`mic-indicator ${on ? 'is-on' : 'is-off'}${on && s.selfSpeaking ? ' is-speaking' : ''}`}
      role="img"
      aria-label={text}
      title={text}
      data-testid="mic-icon"
      data-state={on ? 'on' : 'off'}
    >
      <Icon name={on ? 'mic' : 'micOff'} size={22} />
      <span className="sr-only" data-testid="mic-state">
        {text}
      </span>
    </span>
  );
}
